// French

export default {
  'Your Details': 'Vos Détails',
  'Hello, $0': 'Bonjour, $0',
  Redeem: 'Racheter',
  Edit: 'Modifier',
}
